import React from 'react';
import { componentService } from 'js/services/component.service';

export const PendingWithdrawals = React.lazy(() => import(/* webpackChunkName: "pending-withdrawals" */ './PendingWithdrawals'));

componentService.registerPageComponents({ 'pending-withdrawals': PendingWithdrawals });
